// extracted by mini-css-extract-plugin
export default {"footer":"footer--1Em-z","footer__content":"footer__content--XV4xV","footer__links":"footer__links--zcqTs","footer__links--blog":"footer__links--blog--2Sk5Q","footer__right":"footer__right--eqBGL","footer__languages":"footer__languages--NNOFL","footer__copyright":"footer__copyright--33L8U","footer__copyright__brand":"footer__copyright__brand--3qtPR","footer__social":"footer__social--oixmf"};
    if(module.hot) {
      // 1747648152010
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  